module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAXUlEQVQY04XOsQ2FMBRD0RMWYCl2SPVbmIURoE2F/giwCuyQDWiIFIQQrq4sv2eLKe8x5R5qLgox5Q4rBhyFl187Q7guX0OhvKpCG8aL58ZT/9uGz4qvkQ2myqgZnHADMcntWBmIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/personal_center/download-details.png
// module id = zaTo
// module chunks = 16